import { defineStore } from "pinia";

import { AI_PHOTO_PREVIEW_SIZES } from "@/components/AiPhoto/constants";

const AI_PHOTO_PREVIEW_SIZE_STORAGE_KEY = "aiPhotoPreviewSize";
const DEFAULT_AI_PHOTO_PREVIEW_SIZE = 64;

function getAiPhotoPreviewSizeFromStorage() {
  if (typeof window === "undefined" || !window.localStorage) {
    return DEFAULT_AI_PHOTO_PREVIEW_SIZE;
  }

  const storedSize = Number(window.localStorage.getItem(AI_PHOTO_PREVIEW_SIZE_STORAGE_KEY));

  if (AI_PHOTO_PREVIEW_SIZES.includes(storedSize)) {
    return storedSize;
  }

  window.localStorage.setItem(AI_PHOTO_PREVIEW_SIZE_STORAGE_KEY, String(DEFAULT_AI_PHOTO_PREVIEW_SIZE));

  return DEFAULT_AI_PHOTO_PREVIEW_SIZE;
}

function saveAiPhotoPreviewSizeToStorage(value) {
  if (typeof window === "undefined" || !window.localStorage) {
    return;
  }

  window.localStorage.setItem(AI_PHOTO_PREVIEW_SIZE_STORAGE_KEY, String(value));
}

export const useAiPhotoStore = defineStore("aiPhotoStore", {
  state: () => ({
    AiPhotoStep: 0,
    aiPhotoFilter: "all",
    aiPhotoPreviewSize: getAiPhotoPreviewSizeFromStorage(),
    selectedPhoto: null,
    isCreatedAiPhoto: false,
    aiPhotoSettingsReGenerate: null,
    selectedModelToAIPhoto: {},
    materialsForAiPhoto: [],
  }),
  actions: {
    setValue(keyValue) {
      if (keyValue?.key in this) {
        this[keyValue.key] = keyValue.value;

        if (keyValue.key === "aiPhotoPreviewSize") {
          saveAiPhotoPreviewSizeToStorage(keyValue.value);
        }
      }
    },
    setModelToAIPhoto(model) {
      this.selectedModelToAIPhoto = model;
    },
    addMaterialsToAIPhoto(material) {
      if (this.materialsForAiPhoto.length === 0) {
        this.materialsForAiPhoto.push(material);
        return;
      }

      const idx = this.materialsForAiPhoto.findIndex((m) => m && m.shader_code === material.shader_code);

      if (idx !== -1) {
        this.materialsForAiPhoto[idx].material = material.material;
      } else {
        this.materialsForAiPhoto.push(material);
      }
    },
    clearMaterialsForAiPhoto() {
      this.materialsForAiPhoto = [];
    },
    SET_VALUE(keyValue) {
      this.setValue(keyValue);
    },
    SET_MODEL_TO_AI_PHOTO(model) {
      this.setModelToAIPhoto(model);
    },
    ADD_MATERIALS_FOR_AI_PHOTO(keyValue) {
      this.addMaterialsToAIPhoto(keyValue);
    },
    CLEAR_MATERIALS_FOR_AI_PHOTO() {
      this.clearMaterialsForAiPhoto();
    },
  },
});

export default useAiPhotoStore;
